export default "__VITE_ASSET__00772ceb__"